// extracted by mini-css-extract-plugin
module.exports = {"range":"score-range_range__1jofQ","rangeValue":"score-range_rangeValue__2a4Yh","rangeDescription":"score-range_rangeDescription__r3Bs-"};